// Jersey helpers without imports (Jest tests them directly). Display and
// input convenience only: the server validates every rule again.

export const LENGAN = ["PENDEK", "PANJANG"];

// Rows pasted from a spreadsheet: Nama <tab> Nomor <tab> Ukuran [<tab> Lengan <tab> Catatan].
// Also accepts ";" as separator. Empty lines and a header row ("nama ...") are skipped.
export function parsePemain(text, ukuranList = []) {
  const rows = [];
  const errors = [];
  String(text || "").split(/\r?\n/).forEach((line, i) => {
    if (!line.trim()) return;
    const cols = (line.includes("\t") ? line.split("\t") : line.split(";")).map((c) => c.trim());
    if (i === 0 && /^nama/i.test(cols[0])) return;  // header row ("Nama", "Nama Pemain", …) from the Excel template
    let ukuran = (cols[2] || "").toUpperCase().replace(/\s+/g, "");
    if (ukuran === "2XL" && ukuranList.includes("XXL")) ukuran = "XXL";  // common spelling of the same size
    if (ukuran === "XXXL" && ukuranList.includes("3XL")) ukuran = "3XL";
    const lenganRaw = (cols[3] || "").toUpperCase();
    const lengan = lenganRaw.startsWith("PANJANG") || lenganRaw === "LP" ? "PANJANG" : "PENDEK";
    if (ukuranList.length && !ukuranList.includes(ukuran)) errors.push(`Baris ${i + 1}: ukuran "${cols[2] || ""}" tidak dikenal`);
    rows.push({ nama: cols[0] || "", nomor: cols[1] || "", ukuran, lengan, catatan: cols[4] || "" });
  });
  return { rows, errors };
}

// Count of players per size, in the order of the size list.
export function rekapPemain(pemain, ukuranList = []) {
  const out = Object.fromEntries(ukuranList.map((u) => [u, 0]));
  (pemain || []).forEach((p) => { out[p.ukuran] = (out[p.ukuran] || 0) + 1; });
  return out;
}

// 0-based row indexes that are part of a duplicate name+number group (as the server does).
export function barisDuplikat(pemain) {
  const norm = (v) => String(v || "").trim().replace(/\s+/g, " ").toLowerCase();
  const seen = {};
  (pemain || []).forEach((p, i) => {
    const key = `${norm(p.nama)}|${norm(p.nomor)}`;
    if (key === "|") return;
    (seen[key] = seen[key] || []).push(i);
  });
  return new Set(Object.values(seen).filter((g) => g.length > 1).flat());
}
